import { ArrayField, Datagrid, DateField, ReferenceArrayField, ReferenceOneField, ShowContextProvider, ShowView, Tab, TabbedShowLayout, TextField, useShowController } from 'react-admin';
import AlertDateField from '../../Components/AlertDateField';
import ContextTitle from '../../Components/ContextTitle';

const CustomerShow = () => {
  const controllerProps = useShowController();

  return (
    <ShowContextProvider value={controllerProps}>
      <ShowView title={<ContextTitle context="name" />}>
        <TabbedShowLayout>
          <Tab label="Summary">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="email" />
            <TextField source="externalId" label="External ID" />
            <TextField source="location.code" />
            <ReferenceOneField reference="organizations" source="organizationUuid" target="uuid">
              <TextField source="uuid" />
            </ReferenceOneField>
          </Tab>
          <Tab label="Subscriptions">
            <ArrayField source="subscriptions">
              <Datagrid>
                <TextField source="uuid" />
                <TextField source="externalId" label="External ID" />
                <TextField source="status" />
                <DateField source="startedAt" />
                <AlertDateField source="endedAt" />
                <DateField source="currentPeriodStartedAt" />
                <AlertDateField source="currentPeriodEndedAt" />
                <DateField source="trialStartedAt" />
                <AlertDateField source="trialEndedAt" />
              </Datagrid>
            </ArrayField>
          </Tab>
          <Tab label="Companies">
            <ReferenceArrayField source="companies" label="Companies" reference="companies">
              <Datagrid>
                <TextField source="name" />
              </Datagrid>
            </ReferenceArrayField>
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    </ShowContextProvider>
  );
};

export default CustomerShow;
